
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerEditor()
    export class IcStockApproveHdEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, IcStockApproveHdRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return IcStockApproveHdRow.lookupKey;
        }

      
    }
}
